import React from 'react';

const Pay = () => {
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col pe-lg-0 scroll-div">
                        <h1 className="display-5 text-center my-5 text-pink">Payment system coming soon...</h1>
                    </div>
                        
                </div>
            </div>
        </div>
    );
};

export default Pay;